import {
  AfterContentInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
} from "@angular/core";
import { Checkbox } from "@bfx/primeng/checkbox";

@Directive({
  selector: "[bfxInputLabelOnClick]",
  standalone: false,
})
export class BfxInputLabelOnClick implements AfterContentInit, OnDestroy {
  checkboxListener: () => void;

  constructor(
    public renderer: Renderer2,
    public checkbox: Checkbox,
  ) {}

  @Input("bfxInputLabelOnClick")
  public component: Element | null = null;

  ngAfterContentInit(): void {
    this.removeListener();
    this.checkboxListener = this.renderer.listen(this.component, "click", ($event) => {
      this.checkbox.onClick($event, null, false);
    });
  }
  private removeListener() {
    if (this.checkboxListener != null) {
      this.checkboxListener();
    }
  }

  ngOnDestroy(): void {
    this.removeListener();
  }
}
